var render = function render(){var _vm=this,_c=_vm._self._c;return _c('no-data',{attrs:{"url":"design/placeholder/zhanweilogo%402x.jpg!width_250px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }